import React from 'react';
import cancelIcon from "../../../img/icon/icon-cancel.svg";

const SelectCertification = ({varPopupSelectCertification,ShowCertificationIssue,varIssueList,ToggleSelectCertification}) => {

  return (
    <div className="layer-pop layer-kids" style={varPopupSelectCertification?{display:"block"}:{display:"none"}}>
      <div className="layer-hd">
        <div className="tit">원생 선택</div>
        <div className="close-layer" onClick={()=>ToggleSelectCertification(false)}><img src={cancelIcon} alt=""/></div>
      </div>
      <div className="check-group vertical">
        <div className="checkbox2" onClick={()=>ShowCertificationIssue(varIssueList,1)}>
          <label className="active">
            <div className="value">
              <div className="name">국문</div>
            </div>
          </label>
        </div>
        <div className="checkbox2" onClick={()=>ShowCertificationIssue(varIssueList,2)}>
          <label className="active">
            <div className="value">
              <div className="name">영문</div>
            </div>
          </label>
        </div>
      </div>
    </div>
  )
}
export default SelectCertification;